import { FormSelect } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import React, { useEffect, useRef, useState } from 'react';
import { deleteBuild, getNames, hide, loadBuild } from './weaveLoadSlice';
import { getTrainerResults } from './weaveTrainerSlice';

function InnerWeaveLoadModal() {
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLSelectElement>(null);
  const prevName = useAppSelector(state => state.weaveSave.name);
  const prevNameRef = useRef(prevName);
  const [name, setName] = useState('');
  const [nameOptions, setNameOptions] = useState([] as string[]);

  useEffect(() => {
    const prevName = prevNameRef.current;
    const options = dispatch(getNames());
    const newName = options.find(x => x === prevName) ?? options[0] ?? '';
    setNameOptions(options);
    setName(newName);
    inputRef.current?.focus();
  }, [dispatch]);

  const handleDeleteClick = () => {
    if (name) {
      const options = dispatch(deleteBuild(name));
      const newName = options[0] ?? '';
      setNameOptions(options);
      setName(newName);
    }
  };

  const handleLoadClick = () => {
    if (name) {
      dispatch(loadBuild(name));
      dispatch(getTrainerResults());
    }
  };

  const handleCloseClick = () => {
    dispatch(hide());
  };
  
  const handleNameChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setName(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLSelectElement>) => {
    if (e.code === 'Enter') {
      e.preventDefault();
      handleLoadClick();
    }
  };

  return (
    <Modal show={true} onHide={() => handleCloseClick()}>
      <Modal.Header closeButton>
        <Modal.Title>Load</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <label>Save Name:</label>
        <FormSelect value={name} onChange={handleNameChange} onKeyDown={handleKeyDown} ref={inputRef}>
          <option value=''>[Select a save]</option>
          {nameOptions.map(x => <option key={x} value={x}>{x}</option>)}
        </FormSelect>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" className="me-auto" onClick={() => handleDeleteClick()}>Delete</Button>
        <Button variant="secondary" onClick={() => handleCloseClick()}>Cancel</Button>
        <Button variant="primary" onClick={() => handleLoadClick()}>Load</Button>
      </Modal.Footer>
    </Modal>
  );
}

function WeaveLoadModal() {
  const visible = useAppSelector(state => state.weaveLoad.visible);
  return visible ? <InnerWeaveLoadModal/> : null;
}

export default WeaveLoadModal;